import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditBrands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pincode: '',
      name: '',
      area: '',
      description: '',
      email: '',
      productCategory: [], // Will store an array of category IDs
      package: '', // Will store the selected package ID
      packageAmount: 0,
      city: '',
      images: [],
      id: null,
      categories: [],
      packages: [],
      brandsnew: '',
      brandsNew: [],
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match?.params?.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
      this.fetchCategories();
      this.fetchPackages();
      this.fetchBrandsNew();
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchCategories = async () => {
    try {
      const response = await axios.get("https://brand.aasmo.in/api/admin/getall-category");
      this.setState({ categories: response?.data?.categories || [] });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  fetchPackages = async () => {
    try {
      const response = await axios.get("https://brand.aasmo.in/api/admin/package");
      this.setState({ packages: response?.data || [] }, this.updatePackageAmount);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };
  fetchBrandsNew = async () => {
    try {
      const response = await axios.get("https://brand.aasmo.in/api/admin/brandsnew");
      this.setState({ brandsNew: response?.data?.data || [] });
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };
  fetchData = async (id) => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/brands/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const brandData = response?.data;
      if (brandData) {
        this.setState({
          name: brandData.name || '',
          area: brandData.area || '',
          pincode: brandData.pincode || '',
          description: brandData.description || '',
          email: brandData.email || '',
          city: brandData.city || '',
          images: brandData.images || [],
          package: brandData.package?._id || '',
          brandsnew: brandData?.brandsNew?._id || '',
          productCategory: brandData.productCategory?.map(category => category._id) || [], // Only store category IDs
        }, this.updatePackageAmount);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  updatePackageAmount = () => {
    const { packages, package: selectedPackage, productCategory } = this.state;
    const basePackageAmount = packages.find(pkg => pkg._id === selectedPackage)?.price || 0;
    this.setState({ packageAmount: basePackageAmount * productCategory.length });
  };

  handleCategoryChange = (e) => {
    const selectedCategories = Array.from(e.target.selectedOptions, option => option.value);
    this.setState({ productCategory: selectedCategories }, this.updatePackageAmount);
  };

  handlePackageChange = (e) => {
    this.setState({ package: e.target.value }, this.updatePackageAmount);
  };
  handleBrandsChange = (event) => {
    console.log("Selected Brand ID:", event.target.value);  // Debugging
    this.setState({ brandsnew: event.target.value });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (e) => {
    this.setState({ images: Array.from(e.target.files) });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id, productCategory, brandsnew, package: selectedPackage, images } = this.state;
    const formData = new FormData();
  
    // Append custom data fields to formData
    formData.append('pincode', this.state.pincode);
    formData.append('name', this.state.name);
    formData.append('area', this.state.area);
    formData.append('description', this.state.description);
    formData.append('email', this.state.email);
    formData.append('packageAmount', this.state.packageAmount);
    formData.append('city', this.state.city);
  
    // Append other form fields
    formData.append('productCategory', JSON.stringify(productCategory));
    formData.append('package', selectedPackage);
    formData.append('brandsNew', brandsnew);
  
    // Append images (if any)
    images.forEach((file) => {
      formData.append('images', file);
    });
  
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
  
      const response = await axios.put(
        `https://brand.aasmo.in/api/admin/brands/${id}`,
        formData,  // Sending formData (which includes all data)
        config
      );
  
      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push('/list-brands');
        }, 2000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  




  render() {
    const { name, area, description, email, city, images, categories, brandsnew, packages, brandsNew, packageAmount, package: selectedPackage, productCategory } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header"><h2>Edit Store</h2></div>
            <div className="card-body">
              <div className="form-group">
                <label>Name</label>
                <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} required />
              </div>

              <div className="form-group">
                <label>Area</label>
                <input type="text" className="form-control" name="area" value={area} onChange={this.handleChange} required />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea className="form-control" name="description" value={description} onChange={this.handleChange} required />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input type="email" className="form-control" name="email" value={email} onChange={this.handleChange} required />
              </div>

              <div className="form-group">
                <label>City</label>
                <input type="text" className="form-control" name="city" value={city} onChange={this.handleChange} />
              </div>
              <div className="form-group">
                <label>Pincode</label>
                <input type="number" className="form-control" name="pincode" value={this.state.pincode} onChange={this.handleChange} required />
              </div>
              {/* Package Selection */}
              <div className="form-group">
                <label>Package</label>
                <select className="form-control" name="package" value={selectedPackage} onChange={this.handlePackageChange} required>
                  <option value="">Select Package</option>
                  {packages.map(pkg => (
                    <option key={pkg._id} value={pkg._id}>{pkg.title} - ₹{pkg.price}</option>
                  ))}
                </select>
              </div>

              {/* Package Amount */}
              <div className="form-group">
                <label>Package Amount</label>
                <input type="text" className="form-control" value={`₹${packageAmount}`} readOnly />
              </div>

              {/* Category Selection */}
              <div className="form-group">
                <label>Product Category</label>
                <select className="form-control" name="productCategory" multiple value={productCategory} onChange={this.handleCategoryChange} required>
                  {categories.map(category => (
                    <option key={category._id} value={category._id}>{category.categoryName}</option>
                  ))}
                </select>
                <small>Select multiple categories by holding Ctrl (Windows) or Command (Mac)</small>
              </div>
              <div className="form-group">
                <label>Brands</label>
                <select
                  className="form-control"
                  name="brandsnew"
                  value={this.state.brandsnew}
                  onChange={this.handleBrandsChange}
                  required
                >
                  <option value="">Select Brands</option>
                  {this.state.brandsNew.map(item => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Image Upload */}
              <div className="form-group">
                <label>Images</label>
                <input type="file" className="form-control" multiple onChange={this.handleFileChange} />
                <div className="col-md-6">
                  {images.map((image, index) => (
                    <img key={index} src={image} alt={`Brand Image ${index + 1}`} className="img-thumbnail mt-2" />
                  ))}
                </div>
              </div>

              <button className="btn btn-primary" type="submit">Submit</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(EditBrands);
